module.exports = __webpack_public_path__ + "static/media/facebook.4ab977a0.svg";